module.exports = __webpack_public_path__ + "img/1583820246.f2302ab9.jpg";